import { HttpClientModule } from '@angular/common/http';
import { InjectionToken, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { EffectsModule } from '@ngrx/effects';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { Action, ActionReducerMap, Store, StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import {  DialogModule, EnabledFeaturesInjectionToken, HeaderModule, SnackbarModule, UsernameTokenModule } from 'elements-lib';
import { ReportsModule, UserStoreModule } from 'pages-lib';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { RouterEffectsEffects } from './shared/effects/router-effects.effects';
import { UserEffects } from './shared/effects/user.effects';
import { PromptsModule } from './shared/prompts/prompts.module';
import * as fromVis from './visualizer/store';
import { VisualizerModule } from './visualizer/visualizer.module';
import { AppStateModule } from './shared/app-state/app-state.module';
import { ConfigProviderService } from './shared/app-state/config-provider.service';
import { selectEmtelliproServer, selectEnabledFeatures } from './shared/app-state/store/app-state.selectors';
import { AuthInterceptorProvider } from './shared/Interceptors/auth-interceptor';
import { LoginComponent } from './pages/auth/login/login.component';
import { ChangePasswordComponent } from './pages/auth/change-password/change-password.component';

const ROOT_REDUCERS = new InjectionToken<ActionReducerMap<fromVis.State, Action>>("Root reducers token",
  {
    factory: () => fromVis.reducers
  });

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    VisualizerModule,
    HttpClientModule,
    StoreModule.forRoot(ROOT_REDUCERS, {}),
    EffectsModule.forRoot([]),
    StoreDevtoolsModule.instrument({ maxAge: 250, logOnly: environment.production }),
    HeaderModule,
    UserStoreModule,
    ReportsModule,
    AppStateModule,
    StoreRouterConnectingModule.forRoot(),
    EffectsModule.forFeature([RouterEffectsEffects, UserEffects]),
    SnackbarModule,
    DialogModule,
    PromptsModule,
    UsernameTokenModule
  ],
  providers: [
    {
      provide: 'env',
      useValue: environment
    },
    {
      provide: 'config',
      useClass: ConfigProviderService
    },
    {
      provide: EnabledFeaturesInjectionToken,
      useFactory: (store: Store) => {
        return store.select(selectEnabledFeatures);
      },
      deps:[
        Store
      ]
    },
    {
      provide: 'emtelliproServer',
      useFactory: (store: Store) => store.select(selectEmtelliproServer),
      deps: [
        Store
      ]
    },
    AuthInterceptorProvider,
    {
      provide: 'AuthPages',
      useValue: {
        Login: LoginComponent,
        ChangePassword: ChangePasswordComponent
      }
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
